import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { Divider } from 'components/shared/Divider';

interface WelcomeHeaderProps {
  firstName?: string | null;
  fullName?: string | null;
  isNameLoading?: boolean;
}

export const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({
  firstName,
  fullName,
  isNameLoading = false,
}) => {
  const displayName = fullName || firstName;

  return (
    <Col className="w-full gap-6">
      <Col className="gap-1">
        <Text as="p" className="text-body-md text-od-content-secondary">
          Welcome back,
        </Text>
        {isNameLoading ? (
          <Col aria-hidden className="h-7 w-40 skeleton rounded-md bg-od-bg-tertiary" />
        ) : (
          <Text as="h1" className="text-subheader-md text-od-content-primary">
            {displayName}
          </Text>
        )}
      </Col>
      <Divider />
    </Col>
  );
};
